<div class="tw-bg-lendio-warm-gray-600 tw-border tw-rounded tw-font-normal tw-leading-none tw-font-[500] tw-text-xs tw-p-2">
    <span class="tw-text-white">{{tooltip}}</span>
</div>